import React, { useEffect } from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Select } from 'antd';

const ACTION_OPTIONS = [
  { value: 'BODY_CHECK', label: 'Body check (scale / measure)' },
  { value: 'WATER', label: 'Water' },
  { value: 'FOOD_BREAKFAST', label: 'Food · Breakfast' },
  { value: 'FOOD_LUNCH', label: 'Food · Lunch' },
  { value: 'FOOD_DINNER', label: 'Food · Dinner' },
  { value: 'FOOD_SNACK', label: 'Food · Snack' },
  { value: 'HOME', label: 'Home' },
];

type TranslationMap = Record<string, { title?: string; body?: string }>;

export const NotificationReminderEdit: React.FC = () => {
  const { formProps, saveButtonProps, query } = useForm({
    resource: 'notification-reminders',
  });

  useEffect(() => {
    const record = query?.data?.data as
      | {
          translations?: TranslationMap;
        }
      | undefined;
    if (!record?.translations || !formProps.form) return;
    const zhHk = record.translations['zh-HK'];
    const zhCn = record.translations['zh-CN'];
    formProps.form.setFieldsValue({
      titleZhHk: zhHk?.title,
      bodyZhHk: zhHk?.body,
      titleZhCn: zhCn?.title,
      bodyZhCn: zhCn?.body,
    });
  }, [query?.data?.data, formProps.form]);

  const originalOnFinish = formProps.onFinish;

  return (
    <Edit resource="notification-reminders" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          const translations: TranslationMap = {};
          if (values.titleZhHk || values.bodyZhHk) {
            translations['zh-HK'] = {
              title: values.titleZhHk || undefined,
              body: values.bodyZhHk || undefined,
            };
          }
          if (values.titleZhCn || values.bodyZhCn) {
            translations['zh-CN'] = {
              title: values.titleZhCn || undefined,
              body: values.bodyZhCn || undefined,
            };
          }
          const {
            titleZhHk: _a,
            bodyZhHk: _b,
            titleZhCn: _c,
            bodyZhCn: _d,
            ...rest
          } = values;
          return originalOnFinish?.({
            ...rest,
            translations:
              Object.keys(translations).length > 0 ? translations : null,
          });
        }}
      >
        <Form.Item label="Code" name="code" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Hour (0-23)" name="hour" rules={[{ required: true }]}>
          <InputNumber min={0} max={23} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Minute (0-59)" name="minute">
          <InputNumber min={0} max={59} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Action" name="actionType" rules={[{ required: true }]}>
          <Select options={ACTION_OPTIONS} />
        </Form.Item>
        <Form.Item label="Title (EN)" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Body (EN)" name="body" rules={[{ required: true }]}>
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item label="Title (zh-HK)" name="titleZhHk">
          <Input />
        </Form.Item>
        <Form.Item label="Body (zh-HK)" name="bodyZhHk">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item label="Title (zh-CN)" name="titleZhCn">
          <Input />
        </Form.Item>
        <Form.Item label="Body (zh-CN)" name="bodyZhCn">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item label="Enabled" name="isEnabled" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
